import { DataLayerManagerInterface } from './dataLayerManager/abstractDataLayerManager';
import {
    HEADER_PROMO_BAR_CATEGORY,
    SHOP_TO_CLUB_CATEGORY,
    ShopToClubEvent,
    SpecificGaEvent,
    TrackClubHeaderBarBannerEvents,
    TrackShopToClubActions,
    TrackShopToClubOptions,
} from './types';

export const shopToClubDismissLabel = 'Click on "X"';

export enum ShopToClubRegistrationResolutions {
    New = 'registration',
    Login = 'login',
    WrongPassword = 'login_failure',
}

export type PrivacyPolicyAcceptanceLabel = 'accepted' | 'not accepted';

export default class ShopToClubTracking {
    private dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    private trackHeaderPromoBarBanner(event: SpecificGaEvent) {
        this.dataLayerManager.sendSpecificEvent(event, {
            category: HEADER_PROMO_BAR_CATEGORY,
        });
    }

    private trackShopToClub(event: SpecificGaEvent, options: TrackShopToClubOptions) {
        this.dataLayerManager.sendSpecificEvent(event, {
            category: SHOP_TO_CLUB_CATEGORY,
            ...options,
        });
    }

    public trackOverlayShown() {
        this.trackShopToClub(ShopToClubEvent.OverlayShown, {
            action: TrackShopToClubActions.OverlayShown,
            label: '',
        });
    }

    public trackOverlayDismissed() {
        this.trackShopToClub(ShopToClubEvent.OverlayDismissed, {
            action: TrackShopToClubActions.OverlayDismissed,
            label: shopToClubDismissLabel,
        });
    }

    public trackPrivacyPolicyShown() {
        this.trackShopToClub(ShopToClubEvent.OverlayShown, {
            action: TrackShopToClubActions.PrivacyPolicyShown,
            label: '',
        });
    }

    public trackPrivacyPolicyAcceptance(label: PrivacyPolicyAcceptanceLabel) {
        this.trackShopToClub(ShopToClubEvent.PrivacyPolicyAcceptance, {
            action: TrackShopToClubActions.PrivacyPolicyAcceptance,
            label,
        });
    }

    public trackRegistration(resolution: ShopToClubRegistrationResolutions) {
        this.trackShopToClub(ShopToClubEvent.RegistrationSuccessful, {
            action: TrackShopToClubActions.RegistrationSuccessful,
            resolution,
        });
    }

    public trackDoiOverlayShown() {
        this.trackShopToClub(ShopToClubEvent.DoiOverlayShown, {
            action: TrackShopToClubActions.DoiOverlayShown,
            label: '',
        });
    }

    public trackProductListingBannerImpression(label: string) {
        this.trackShopToClub(ShopToClubEvent.ProductListingBannerImpression, {
            action: TrackShopToClubActions.ProductListingBannerImpression,
            label,
        });
    }

    public trackProductListingBannerClick(label: string) {
        this.trackShopToClub(ShopToClubEvent.ProductListingBannerClick, {
            action: TrackShopToClubActions.ProductListingBannerClick,
            label,
        });
    }

    public trackHeaderBannerShown() {
        this.trackHeaderPromoBarBanner(TrackClubHeaderBarBannerEvents.promotionHeaderBarShown);
    }

    public trackHeaderBannerClicked() {
        this.trackHeaderPromoBarBanner(TrackClubHeaderBarBannerEvents.promotionHeaderBarClicked);
    }

    public trackHeaderBannerDismissed() {
        this.trackHeaderPromoBarBanner(TrackClubHeaderBarBannerEvents.promoHeaderBarDismissed);
    }
}
